// extracted by mini-css-extract-plugin
export default {"menuBlock":"QN-z","title":"RN-z","nav":"SN-z","flexCell":"TN-z","facetLink":"UN-z"};